import { createConsumer } from "@rails/actioncable";

let consumer = null;
let currentToken = null;

export const createCable = (token) => {
  if (!token) {
    return null;
  }

  const wsUrl =
    process.env.NODE_ENV === "development"
      ? `ws://localhost:3000/cable?token=${token}` ||
        `ws://localhost:3001/cable?token=${token}`
      : `wss://app.carepet.ai/cable?token=${token}`;

  try {
    const newConsumer = createConsumer(wsUrl);
    return newConsumer;
  } catch (error) {
    return null;
  }
};

export const getCable = (token) => {
  if (!token) {
    return null;
  }

  if (token !== currentToken || !consumer) {
    if (consumer) {
      try {
        consumer.disconnect();
      } catch (e) {}
    }

    currentToken = token;
    consumer = createCable(token);
  }

  return consumer;
};

export default getCable;
